import { render } from "./VisoresConsolidado.vue?vue&type=template&id=b4ec78f8"
import script from "./VisoresConsolidado.vue?vue&type=script&lang=js"
export * from "./VisoresConsolidado.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__